import { Component, Inject, ElementRef,ViewChild, Optional, OnInit,Injectable, Input } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBoxTreeComponent } from './dialog-box-tree.component';

import {SelectionModel} from '@angular/cdk/collections';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {BehaviorSubject} from 'rxjs';

import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { first } from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import { UtilsService } from 'app/main/services/utils.service';

import { DialogBoxPrintComponentFormulario } from './dialog-print-box.component';
import { Router } from '@angular/router';
import { FormularioService } from 'app/main/services/formulario.service';
import { Formulario } from 'app/main/models/formulario.model';
import { FormularioItem } from 'app/main/models/formulario-item.model';


interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}

@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss']
})
export class DialogBoxComponent {

  href: string = "";
    
  action: string;
  LOCAL_DATA: any;
  isLoaded = false;
  nombreOrigen = "";

    tipos = [
        { nombre: 'Simplificada', value: 'SIMPLIFICADA' },
        { nombre: 'Ampliada', value: 'AMPLIADA' },
        { nombre: 'Ambas', value: 'SIMPLIFICADA_Y_AMPLIADA' },
    ];

  private _transformer = (node: FormularioItem, level: number) => {
    return {
      expandable: !!node.sentencias && node.sentencias.length > 0,
      name: node.nombre,
      level: level,
      descripcion: node.descripcion
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(
      node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.sentencias);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  dataSourceList = [];
  tiposEvaluacion = [];

  @ViewChild('tipoInput') tipoInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(
    private service: FormularioService,
    public dialog: MatDialog,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    private _snackBar: MatSnackBar,
    public utils:UtilsService,
    public router: Router,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {

      this.href = this.router.url;
      console.log(data);
        this.dialogRef.disableClose = true;
      this.LOCAL_DATA = {...data.obj};
      this.nombreOrigen = this.LOCAL_DATA.nombre;
      this.dataSourceList = data.dataSource;
      this.LOCAL_DATA.sentencias = data.obj.sentencias || [];
      this.orderStructure(this.LOCAL_DATA.sentencias);
      this.dataSource.data = this.LOCAL_DATA.sentencias;
      this.action = data.action;
  }

  print():void{

    const dialogRef = this.dialog.open(DialogBoxPrintComponentFormulario, {
      width: '100%',
      data: {action:"Print", obj:this.LOCAL_DATA},
      autoFocus: false,
      disableClose: true
    });

  }

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  doAction(): void{
    if(this.nombreOrigen==this.LOCAL_DATA.nombre && this.action==='Duplicate'){
      this.openSnackBar("Ya existe un formulario con el nombre "+this.LOCAL_DATA.nombre,"Cerrar");
    }else{
      this.dialogRef.close({event: this.action, data: this.LOCAL_DATA, dataSource:this.dataSourceList});
    }
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {
    if(this.LOCAL_DATA.id!=null){
      this.service.get(this.LOCAL_DATA.id).pipe().subscribe(req => {
        this.LOCAL_DATA = new Formulario(req.body);
        //this.dataSourceList = data.dataSource;
        this.orderStructure(this.LOCAL_DATA.sentencias);
        this.dataSource.data = [...this.LOCAL_DATA.sentencias];
        this.isLoaded = true;
      });
    }else{
      this.isLoaded = true;
    }
  }

  openDialog(action, obj): void {
    obj.action = action;
    obj.info = this.LOCAL_DATA;
    const dialogRef = this.dialog.open(DialogBoxTreeComponent, {
      width: '100%',
      data: obj,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result.event=='Modifier'){
          this.ngOnInit();
      }else if(result.event!='Cancel'){
        this.LOCAL_DATA.sentencias = [...result.data];
        this.dataSource.data = [...this.LOCAL_DATA.sentencias];

      }else{
        this.LOCAL_DATA.sentencias = [...result.data];
      }

    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }

  orderStructure(sentencias):void{
    if(sentencias!=null)
      for(var z=0; sentencias.length>z;z++){
        sentencias.sort(this.utils.sortAlphaNum);
        //sentencias.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
        this.orderStructure(sentencias[z].sentencias);
      }
  }


}
